/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useContext, useState} from 'react'
import {useDispatch} from 'react-redux'

import {getTicketCategories} from '../action/actionCreators'
import TicketCategoryForm from './TicketCategoryForm'
import API from 'config/API'

import {Notifier} from 'components/Notifier'
import { ModalContext } from 'context/ModalContext'

const AddTicketCategory = (props) => {
  const dispatch = useDispatch()
  const {hideModal} = useContext(ModalContext)
  const [loading, setLoading] = useState(false)

  const onSubmit = async (values, setError) => {
    try {
      setLoading(true)
      await API.post(`/ticket/ticket_categories`, {...values, ticket_team_id: props.id})
      setLoading(false)
      dispatch(getTicketCategories(1, 10, props.ticketTeamId, ''))
      hideModal()
      Notifier.successMessage('Category has been created!')
    } catch (error) {
      for (let err in error.response.data.errors) {
        setError(err, {message: error.response.data.errors[err][0]})
      }
      setLoading(false)
    }
  }

  return <TicketCategoryForm onSubmitHandler={onSubmit} loading={loading} />
}

export default AddTicketCategory
